import ReactLoading from "react-loading";

const Loader = () => {
  return <ReactLoading type="spin" color="#dadada" width="4rem" />;
};

export { Loader };
